module.exports = __webpack_public_path__ + "img/discover.383408de.svg";